const initialState = {
  allCategoryList: [],
  listState: null,
};

// 演出列表
export default function receiveShowDate(state = initialState, action) {
  switch (action.type) {
  case 'ALL_CATEGOYR_LIST':
    return { ...state, allCategoryList: action.payload };
  case 'SAVE_LIST_STATE':
    return { ...state, listState: action.payload };
  case 'CLEAR_LIST_STATE':
    return { ...state, listState: null };
  default:
    return state;
  }
}